<template>
  <div class="container lms-wrapper-two">

    <researcher-nav @do-logout="logout" />

    <div class="lms-content" @click="closeLevel2()">
      <stf-header class="filled" ref="lmsv4header" />

      <div class="lms-content-body" style="height: calc(100vh - 80px); overflow: auto">
        <div v-if="befcr==1" class="d-flex align-items-center justify-content-center ht-100p wd-100p">
          
          <div class="card rounded-20">
            <div class="card-body">
              <div class="wd-400">
                <h3 class="tx-color-01 mg-b-5">Зар</h3>
                <p class="tx-color-03 tx-16 mg-b-40">{{ adName }}</p>

                <div class="form-group">
                  <div class="d-flex">
                    <label class="font0weight-bolder">Төслийн нэр</label>
                    <label class="mg-l-auto text-muted">/Монгол хэл дээр/</label>
                  </div>
                  <input v-model="adVal" type="text" class="form-control" placeholder="Төслийн монгол нэрийг бичнэ үү">
                </div>
                
                <button @click="initAfter(0)" class="btn btn-brand-02 btn-block">Мэдүүлгийн маягт бөглөх</button>
                <div class="divider-text">эсвэл</div>
                <button @click="$router.go(-1)"  class="btn btn-outline-light btn-block">Буцах</button>
                
                
              </div>
            </div>
          </div>
        </div>
        <div class="mg-20 bg-white rounded-20 pd-20" v-else-if="befcr==2 && taskRdy">

          <div class="row">
            <div class="col-4 d-none">





            <div class="pd-b-10">
              <label class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10">Төслийн мэдээлэл</label>
              <nav class="nav nav-sidebar tx-13">
                <a v-for="(b, i) in task.b" role="button" :key="i" @click="taskActiveMenu=b.id" :class="`nav-link ${b.id==taskActiveMenu?'active':''} `">
                  <feather type="folder" style="height: 16px !important; width: 16px !important" class="mg-r-5"></feather>
                  <span>{{ b.nm }}</span>
                </a>
              </nav>
            </div>


            </div>
            <div class="col-12">
              <div v-if="taskActiveMenu==0">
                
                
                        <!--
                          @on-task-detail="$emit('on-task-detail', $event)"
                          @on-show-value="onShowValue"
                          @on-reload="$emit('on-task-reload', $event)"
                          @on-task-field-set-local="
                            obj.data.task[$event.fieldName] = $event.value
                          "
                           @ebarimt-return="ebarimtReturn"
                          @on-attach="showFile" -->

              </div>
              <div>
                <!-- <div v-for="(b, i) in task.b" :key="i">
                  <loader v-if="taskActiveMenu==b.id"
                    :ref="`ldr_box_${b.id}`"
                    :key="`b_${i}`"
                    :box="b"
                    :parentTask="task"
                    :obj="{ data: { task: task }}"
                    :activeBox="taskActiveMenu"
                    :prms="{ boxChooser: false }"
                    :detailSettingProp="{
                      boxSetting: {
                        listSetting: { height: 0 },
                        hideToolbar: true,
                        hideEmptyTemplate: true,
                        autoHeight: true,
                      },
                    }"
                  />
                </div> -->


                <div v-for="(b, i) in task.b" :key="i">
            <div class="card mg-b-20 mg-lg-b-25">
              <div
                class="
                  card-header bg-light
                  pd-y-15 pd-x-20
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <h6 class="tx-uppercase tx-semibold mg-b-0">
                  {{ i + 1 }}. {{ b.nm }}
                </h6>

                <div v-if="i==0">
                  <a @click="processSidebr=true" class="btn btn-info">Явц харах</a>
                </div>
                <nav class="nav nav-with-icon tx-13 mg-l-20">
                  <!-- style="min-width: 240px" -->
                  <!-- <a @click="openAdd(b)" class="nav-link" role="button"><feather type="edit" class="mg-r-5 ht-20-f wd-20-f"></feather> Засах</a>
                  <a @click="openAdd(b)" class="nav-link" role="button"><feather type="trash-2" class="mg-r-5 ht-20-f wd-20-f"></feather> Устгах</a>-->
                  <a v-if="i==0" @click="openTaskEdit(task)" class="btn btn-primary" role="button">
                    <feather
                      type="edit"
                      class="mg-r-5 ht-20-f wd-20-f"
                    ></feather
                    >Үндсэн мэдээлэл шинэчлэх

                    <!-- <button @click="openTaskEdit(task)" role="button" class="btn btn-xs btn-light">Үндсэн мэдээлэл шинэчлэх</button> -->
                  </a>
                  <a v-else-if="b.ot!=6" @click="openAdd(b)" class="nav-link" role="button">
                    <feather
                      type="plus"
                      class="mg-r-5 ht-20-f wd-20-f"
                    ></feather
                    >Нэмэх
                  </a>
                  <template v-if="taskModel.i8<=0 && i==0">
                    <button @click="saveRealBefore" class="btn text-white btn-success mg-l-20 wd-200">Төсөл илгээх</button>
                  </template>
                </nav>
              </div>
              <!-- card-header -->
              <div class="card-body pd-10" v-if="i==0">
                
                  <div class="">
                    
                    <div class="d-flex  justify-content-between mg-b-10 bd-b bd-2 pd-b-10">
                      <div class="wd-50p">
                        <ul class="list-group wd-100p">
                          <li v-for="(b,bi) in task.b.filter(x=>x.id!=0)" :key="bi" class="list-group-item wd-100p d-flex align-items-center">
                            <feather type="menu" class="mg-r-10 ht-20-f wd-20-f text-muted-xl"></feather>
                            {{ b.nm }}
                            <div class="badge badge-primary mg-l-auto text-white tx-14">{{ b.taskCount }}</div>
                          </li>
                        </ul>
                      </div>
                      <div class="bd-l bd-2 pd-l-10">
                        <div class="alert alert-warning mg-b-20" role="alert">
                          <h6 class="alert-heading">Санамж !</h6>
                          <p>Төсөл бүртгүүлэхтэй холбоотой асуудал гарвал <b>18</b> цагаас өмнө <b>11-315741</b> утсаар холбогдоно уу.</p>
                          <hr>
                          <p class="mb-0">Материал хүлээн авах сүүлийн хугацаа: <b>{{ adTask.d2 | moment('YYYY.MM.DD-ны HH:mm') }}</b></p>
                        </div>
                      </div>
                    </div>


                    <task-info class="wd-100p"
                      :fields="fields"
                      :obj="{ data: { task: task }}"
                      :loaded="fetched"
                      :boxId="0"
                      :parentTask="null"
                      @on-attach="showFile"
                    />
                  </div>
              </div>
              <div class="card-body bx-embed-outer pos-relative pd-0" v-else>
                <loader
                  :ref="`ldr_box_${b.id}`"
                  :box="b"
                  :prms="{ boxChooser: false }"
                  :detailSettingProp="{
                    boxSetting: {
                      listSetting: { height: 0 },
                      hideToolbar: true,
                      hideEmptyTemplate: true,
                      autoHeight: true,
                      hideFooter: true
                    },
                  }"
                  @on-attach="showFile($event)"
                  @on-detail="showDetail"
                  @load-box="loadBoxData"
                />
                <!-- @on-detail="showDetail"
                  @load-box="loadBoxData" -->
                <!-- @show-edit="editShow($event)"
                            @box-edit="editBox"
                            @box-delete="deleteBoxConfirm"
                            @on-detail="showDetail"
                            @on-attach="showFile($event)"
                            @load-box="loadBoxData"
                            @update-box-count="b.attachCount = $event.count; b.formCount = $event.count;"
                            @box-loaded="boxLoading=false;"
                            @on-reload-parent="init($event)"
                @on-exam-report="onExamReport"-->
              </div>
              <!-- card-footer -->
            </div>
          </div>
              </div>
            </div>
          </div>
          
          <div class="d-flex wd-100p">
            <button @click="$router.go(-1)" class="btn btn-light">Буцах</button>
            <template v-if="taskModel.i8<=0">
              <button @click="saveFake" class="btn text-white btn-warning mg-l-auto wd-200">Хадгалах</button>
              <button @click="saveRealBefore" class="btn text-white btn-success mg-l-20 wd-200">Төсөл илгээх</button>
            </template>
          </div>
        </div>
      </div>


    </div>

    <div>



    </div>

    <task-edit
                  wd="55%"
                  :prms.sync="taskEdit"
                  labelPosition="top"
                  :show.sync="taskEdit.show"
                  :disablePreEditCheck="true"
                  @on-task-posted="taskPosted"
                @on-edit-close="editClosed"
                @on-attach="showFile"
                ></task-edit>

    <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      propWidth="50%"
      @on-task-detail="showDetail"
      @on-task-delete="taskDeleted"
      @on-task-reload="taskUpdated"
      @on-task-close="taskDialogSide.id = 0"
      :detailSettingProp="{
        hideMainMenu: true,
        showMiniMenu: true,
        hideExecution: true,
        hideProcess: true,
      }"
    ></task-detail-side>

    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <div v-if="processSidebr" class="off-canvas off-canvas-overlay off-canvas-right wd-80p show">
      <!-- any content goes here -->
      <a @click="processSidebr=false" role="button" class="close"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></a>
      <div class="pd-25 ht-100p tx-13">
        <div class="d-flex">
          <div class="wd-50p">
            <transfers
              :task="task"
              @on-transfers-loaded="transfers = $event"
            />
          </div>
          <div class="wd-50p ">
            <task-process
              :task="task"
              :columns="columns"
              :users="pinnedUsers"
              :transfers.sync="transfers"
              class="pd-10"
            ></task-process>
          </div>
        </div>

      </div>
    </div>
    <div v-if="processSidebr" class="backdrop"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import loader from "@/components/box/loader/loader.vue";

import { request } from "@/api/all";
import { getDetailFields } from "@/api/taskCore";
import { getTaskPinnedUsers } from "@/api/taskInUser";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

import { hasOneOf } from "@/libs/tools";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Drawer } from "element-ui";

export default {
  components: {
    vueCustomScrollbar, loader, Drawer,
    transfers: () => ({
      component: import("@/components/task/components/transfers"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskProcess: () => ({
      component: import("@/components/task/components/transfers/activity.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    researcherNav: () => ({
      component: import("@/views/home/apps/stf/researcher/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    stfHeader: () => ({
      component: import("@/views/home/apps/stf/researcher/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),

    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskInfo: () => ({
      component: import("@/components/task/detail/ot/components/info.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data() {
    return {
      processSidebr: false,
      drawerDta: true,
      task: {
        b:[]
      },
      transfers: [],
      pinnedUsers: [],
      columns: [],
      profile: {
        b:[]
      },
      taskInfKey: 0,
      taskActiveMenu: 0,
      taskModel: {},
      taskRdy: false,
      prjId: null,
      prjOt: null,
      taskEdit: {
        id: 0,
        boxId: 0,
        show: false,
        render: false,
        objectTypeId: 0,
        projectId: 0,
        parentId: 0,
        fillAfter:{
          organizationTaskId: null
        }
      },

      fields: [],
      fetched: false,
      taskDialogSide: {
        show: false,
        id: 0,
        boxId: 0,
        key: 0,
      },
      fileDialog: {
        show: false,
        id: 0
      },
      befcr: 0,
      adTask:{
        d2: null,
      },
      adName: '',
      adVal: '',
      servertime: null,
    };
  },
  mounted() {    
    let prj = this.$store.state.app.groupDefaultProjects.filter(
      (x) => x.objectTypeId == parseInt(561, 10)
    );

    if (prj.length > 0) {
      this.prjId = prj[0].id;
      this.prjOt = prj[0].objectTypeId;
    }

    request({
      api: { method: "POST", url: "taskCore/GetCoreList" },
      data: {
        skip: 0,
        size: 50,
        projectId: this.prjId,
        //ot: this.prjOt,
        model: {
          organizationTaskId: this.$route.params.id,
          userId: this.$store.state.user.userId,
        }
      },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        if(res.data.allCount>0){
          request({
            api: { method: "get", url: "task/info" },
            params: { id: this.$route.params.id },
            store: this.$store,
          }).then((resi) => {
            if (res != false) {
              //console.log('resi', resi);
              this.adTask= resi.data.task;

              this.befcr= 2;
              this.initAfter(res.data.tasks[0]['id']);
            }
          });
        }else{
          request({
            api: { method: "get", url: "task/info" },
            params: { id: this.$route.params.id },
            store: this.$store,
          }).then((resi) => {
            if (res != false) {
              //console.log('resi', resi);
              this.adTask= resi.data.task;
              this.adName= resi.data.task.task;
              this.befcr= 1;
            }
          });
          //this.initAfter(0);
        }
        //console.log('step -1', res);
      }
    });
    
    //this.initAfter(0);

    // request({
    //     api: { method: "GET", url: "task/taskInheritedDetail" },
    //     params: { id: 3429418 },
    //     store: this.$store,
    //   }).then((res) => {
    //     this.profile = res.data.task;
    //   }
    //   );
  },
  methods: {
    logout() {
      this.$refs.lmsv4header.logout();
    },
    searchHandler() {
      //console.log('srch handled');
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
      //console.log(shown, this.navbarMode);
    },
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init(id) {
      request({
        // api: { method: "POST", url: "v2/learn/studentHomeData" },
        api: { method: "GET", url: "task/TaskInheritedDetail" },
        params: { id: id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.columns = res.data.columns;
          this.task = res.data.task;
          //console.log('lft', this.task.ltFields);
          this.task.b.unshift({id: 0, nm: 'Ерөнхий мэдээлэл'});
          if(this.task.organizationTask!=null){
            if(this.task.organizationTask.locTypeId==251286 || this.task.organizationTask.locTypeId==162068){
              this.task.b= this.task.b.filter(x=> !hasOneOf([x.ot], [562, 563, 564, 566, 565]) );
              if(!this.task.isCompleted){
                this.task.b= this.task.b.filter(x=> !hasOneOf([x.ot], [594]) );
              }
            }

            
          }
          //console.log('this.task', this.task);
          //this.task.b=[];

          this.initFields(this.task.objectTypeId);
          this.initUsers();

          //this.openTaskEdit(this.task);
          

          //this.initAfter(this.task.id, 561);
        }
      });
    },
    initUsers(){
      getTaskPinnedUsers({
        params: { taskId: this.task.id, page: 0, size: 20 },
        store: this.$store,
      }).then((res) => {
        if (res != false) {

          //this.pinnedUsers = res.data.users;
        }
      });
    },
    openTaskEdit(task){
      this.taskEdit.id = task.id;
      this.taskEdit.objectTypeId = task.objectTypeId;
      this.taskEdit.projectId = task.projectId;
      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    openAdd(b) {
      //console.log(b);
      this.taskEdit.id = 0;
      this.taskEdit.boxId = b.id;
      this.taskEdit.objectTypeId = b.ot;
      this.taskEdit.projectId = b.projectId;
      this.taskEdit.fillAfter.organizationTaskId = this.task.id;
      //this.taskEdit.parentId = this.profile.id;
      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    initFields(ot) {
      getDetailFields({ params: { objectTypeId: ot } }).then((res) => {
        if (res != false) {
          this.fields = res.data.fields;

          if(this.task.organizationTask!=null){
            if(this.task.organizationTask.locTypeId==251286 || this.task.organizationTask.locTypeId==162068){
              let _decfs= [];

              _decfs.push('locTypeId2');
              _decfs.push('locTypeId5');
              _decfs.push('locTypeId6');
              _decfs.push('divider1');
              _decfs.push('locTypeIds2');
              _decfs.push('taskDesc');
              _decfs.push('s1');
              _decfs.push('s2');
              _decfs.push('defaultAttachmentId');
              _decfs.push('secondAttachmentId');
              _decfs.push('s3');
              _decfs.push('s4');
              _decfs.push('s5');
              _decfs.push('s6');
              //_decfs.push('locTypeId4');

              _decfs.push('thirdAttachmentId');
              _decfs.push('fourthAttachmentId');
              _decfs.push('fl1');


              if(this.taskModel.organizationTask.locTypeId==251286){
                _decfs.push('dueStartDate');
                _decfs.push('dueDate');
              }

              this.fields = this.fields.filter((x) => !hasOneOf([x.field], _decfs) ); 
            }

            // if(hasOneOf(['stf_proj_sudlaach'], this.$store.state.user.access)){
            if(!hasOneOf(['stf_proj_admin', 'stf_shupz', 'stf_proj_mergejilten'], this.$store.state.user.access)){
              let _decfs= [];
              _decfs.push('fl1');
              this.fields = this.fields.filter((x) => !hasOneOf([x.field], _decfs) ); 
            }
          }
          
          //this.fields = this.fields.filter((x) => !hasOneOf([x.field], _decfs) ); 
          this.fetched = true;
        }
      });
    },
    taskPosted(e) {
      //console.log('taskPosted', e);
      //this.$refs[`ldr_box_${e.prms.boxId}`][0].init();
      if(e.prms.boxId>0){
        this.$refs[`ldr_box_${e.prms.boxId}`][0].reInit();
      }else{
        this.init(e.obj.id);
        //this.taskInfKey++;
      }
      this.editClosed();
    },
    editClosed() {
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    initAfter(id){
      console.log('initAfter', id);

      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: id,
          objectTypeId: this.prjOt,
          parentId: 0,
          projectId: this.prjId,
          boxId: 0,
          userId: this.$store.state.user.userInfo.userId,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.taskRdy= true;
          this.taskModel= res.data.task;
          if(id==0){
            this.taskModel.task= this.adVal;
            this.taskModel.i8= -1;
            //this.taskModel.task= this.$store.state.user.userInfo.fullName;
            this.taskModel.organizationTaskId= this.$route.params.id;
            //console.log('step 0', this.$store.state.user.userInfo.fullName);
            this.saveDta();
          }else{
            this.init(res.data.task.id);
            console.log('step 1', res);
          }
        }
      });
    },
    saveDta() {
      // console.log('saveDta step 1');
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.taskModel },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          console.log('saveDta step 1', res.taskId);
          this.befcr=2;
          this.init(res.taskId);
          //console.log('step 2', res);
        }
      });
    },
    showDetail(e) {
      //console.log('showDetail', e);
      this.taskDialogSide.boxId = e.boxId;
      this.taskDialogSide.id = e.id;
    },
    loadBoxData(e) {
      //console.log('loadBoxData', e);
    },
    taskDeleted() {
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
      this.editClosed();
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    taskUpdated(e){
      this.taskDialogSide.id = 0;
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
      //console.log('taskUpdated', e);
    },
    saveFake(){
      Notification.warning({
        title: "Мэдээлэл хадгалагдлаа",
        message: `${moment(this.adTask.d2).format("yyyy.MM.DD HH:mm") }-с өмнө ШУТСАН-д илгээх шаардлагатайг анхаарна ууs`,
        duration: 30000,
        position: "bottom-right",
      });
    },
    saveRealBefore(){
      request({
        api: { method: "GET", url: "servertime" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.servertime= res.data.now;
          this.saveReal();
        }
      });
    },
    saveReal(){
      let errs=[];

      if (moment(this.adTask.d2).isBefore(moment(this.servertime))) {
        errs.push('Хүсэлт авах хугацаа өнгөрсөн байна');
      }

      

      if(errs.length>0){
        Notification.warning({
          title: "",
          message: `${ errs[0] }`,
          duration: 30000,
          position: "bottom-right",
        });
      }else{

        //console.log('sdfsdf', this.taskModel.id, this.task.id);
        let _rid= this.taskModel.id;
        if(_rid<=0){
          _rid= this.task.id;
        }
        console.log('rid', _rid, this.task);
        request({
          api: { method: "GET", url: "Task/GetInherited" },
          params: {
            //id: this.taskModel.id, 1006 uurchlub
            id: _rid,
            objectTypeId: this.prjOt,
            parentId: 0,
            projectId: this.prjId,
            boxId: 0,
            userId: this.$store.state.user.userInfo.userId,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            let _sdta= res.data.task;
            _sdta.i8=1;
            request({
              api: { method: "POST", url: "Task/PostInherited" },
              data: { model: _sdta },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                // name: 'stfResearcherList',
                //   params: { type: 1 },
                Notification.info({
                  title: "",
                  message: `Амжилттай илгээлээ`,
                  duration: 30000,
                  position: "bottom-right",
                });
                this.$router.push({name: 'stfResearcherList', params: {type: 4 } });
              }
            });
            // this.taskRdy= true;
            // this.taskModel= res.data.task;
            // if(id==0){
            //   this.taskModel.task= this.adVal;
            //   //this.taskModel.task= this.$store.state.user.userInfo.fullName;
            //   this.taskModel.organizationTaskId= this.$route.params.id;
            //   //console.log('step 0', this.$store.state.user.userInfo.fullName);
            //   this.saveDta();
            // }else{
            //   this.init(res.data.task.id);
            //   console.log('step 1', res);
            // }
          }
        });
        
      }
    },
  },
};
</script>
<style lang="less">
.bx-embed-outer{
  .filemgr-content-body{
    position: relative;
    .pd-x-10{
      height: auto !important;
    }
  }
}
</style>